module.exports = __webpack_public_path__ + "static/media/drive_car2.7d311d11.jpg";